/**
 * Quick Shop size pickers for Simple Bundles products ("Pre Black Friday" theme, 2026-11-03).
 *
 * The Simple Bundles app adds its size dropdowns with JS on the product page only, so Quick
 * Shop showed bundles with no way to choose sizes. When Quick Shop opens, this fetches
 * /products/<handle>?view=qb-bundle (templates/product.qb-bundle.liquid ->
 * snippets/quickbuy-bundle-options.liquid). Non-bundles return nothing and are skipped.
 * Loaded site-wide by a Custom Liquid section in the footer group.
 */
(function () {
  if (window.__qbBundleOptions) return;
  window.__qbBundleOptions = true;

  function productHandle(form) {
    var container = form.closest('.quickbuy-container');
    var link = container && container.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = new URL(link.href, location.origin).pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function initForm(form) {
    if (!form || form.dataset.qbBundleInit) return;
    if (!form.closest('.quickbuy-container')) return;
    // Only the buy-buttons form (skip the Shop Pay installments form, which is also a cart form).
    if (!form.classList.contains('js-product-form') || !form.querySelector('.quantity-submit-row')) return;
    if (form.querySelector('#simple-bundles-io-options, [data-simple-bundles-options]')) return;
    var handle = productHandle(form);
    if (!handle) return;
    form.dataset.qbBundleInit = 'loading';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + handle + '?view=qb-bundle', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim() || form.querySelector('.qb-bundle-options')) {
          form.dataset.qbBundleInit = 'none';
          return;
        }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var anchor = form.querySelector('.quantity-submit-row');
        while (holder.firstChild) form.insertBefore(holder.firstChild, anchor);
        form.dataset.qbBundleInit = 'ready';
        form.classList.add('qb-bundle-form');
        wire(form);
      })
      .catch(function () { delete form.dataset.qbBundleInit; });
  }

  function wire(form) {
    var wrap = form.querySelector('.qb-bundle-options');
    if (!wrap) return;
    var selects = Array.prototype.slice.call(wrap.querySelectorAll('select'));
    var selection = wrap.querySelector('[data-qb-bundle-selection]');
    var error = wrap.querySelector('.qb-bundle-options__error');

    function update() {
      // Same format the Simple Bundles app writes on the product page, e.g. "6 <> 6"
      if (selection) selection.value = selects.map(function (s) { return s.value; }).join(' <> ');
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        s.classList.remove('qb-bundle-options__select--error');
        if (error && selects.every(function (x) { return x.value; })) error.hidden = true;
        update();
      });
    });
    update();
  }

  // Block Add to Cart until every bundle item has a size (capture phase, before theme handlers).
  function guard(evt) {
    var form = null;
    if (evt.type === 'submit') {
      form = evt.target;
    } else if (evt.target.closest) {
      var btn = evt.target.closest('button[type="submit"], [name="add"]');
      form = btn ? (btn.form || btn.closest('form')) : null;
    }
    if (!form || !form.dataset) return;
    var state = form.dataset.qbBundleInit;
    if (state === 'loading') { evt.preventDefault(); evt.stopImmediatePropagation(); return; }
    if (state !== 'ready') return;

    var missing = Array.prototype.slice
      .call(form.querySelectorAll('.qb-bundle-options select'))
      .filter(function (s) { return !s.value; });
    if (!missing.length) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    missing.forEach(function (s) { s.classList.add('qb-bundle-options__select--error'); });
    var error = form.querySelector('.qb-bundle-options__error');
    if (error) error.hidden = false;
    missing[0].focus();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  function scan() {
    document
      .querySelectorAll('.quickbuy-container form[action*="/cart/add"]')
      .forEach(initForm);
  }

  document.addEventListener('on:quickbuy:after-open', scan);

  // Fallback in case Quick Shop content is inserted without the theme event.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  scan();
})();
